import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { registerServiceWorker } from './lib/service-worker-setup';
import { requestNotificationPermission } from './lib/notifications';

// Render app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support
if (import.meta.env.PROD) {
  registerServiceWorker().then((registration) => {
    if (registration) {
      console.log('PWA enabled - Service Worker registered');

      // Request notification permission after SW registration
      requestNotificationPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notifications enabled');
        }
      });
    }
  });
}
